import React, { Component } from 'react';
import {
  Grid,
  Button
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl } from 'react-intl';
import Scroll from 'react-scroll';
import cx from 'classnames';
import cs from '../../../components/commonStyle.css';
import s from './EarnBlock.css';
import history from '../../../core/history';
import icon from '/public/SiteIcons/arrow-right-white-small.svg';
import { connect } from 'react-redux';

let Link = Scroll.Link;

class EarnBlock extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { isAuthenticated } = this.props;
    if (isAuthenticated) {
      history.push('/become-a-owner?mode=new');
    } else {
      history.push('/login?refer=/become-a-owner?mode=new');
    }
  }

  render() {
    const { data } = this.props
    return (
      <Grid className={s.centerBlock}>
        <div className={s.mainBlock}>
          <h2 className={s.heading}>
            {data && data.earnBlockTitle1}
          </h2>
          <h3 className={s.estimate}>
            {data && data.earnBlockContent1}
          </h3>
          <div className={cx(cs.dFlex, s.noflex, cs.spaceTop6, cs.justifyCenter)}>
            <Button
              className={cx(s.listButton, cs.btnThemeSecondary)}
              onClick={this.handleClick}
            >
              <span>{data?.buttonLabel} </span>
              <img src={icon} className='imgIconRight' />
            </Button>
            {/* <Link
              to="scrollSection"
              spy={true}
              smooth={true}
              offset={1}
              duration={500}
              className={cx(cs.btnThemeSecondaryOutline, s.learnBtnCss, 'learnBtnCssRTL')}
            >
              <span>{data?.buttonLabel2} </span>
            </Link> */}
          </div>
        </div>
      </Grid>
    );
  }
}

const mapState = (state) => ({
  isAuthenticated: state.runtime.isAuthenticated
});

export default connect(mapState)(injectIntl(withStyles(s, cs)(EarnBlock)));
